import React, { useState, useEffect } from "react"
import { Card, Form, Row, Col, Button } from "react-bootstrap"
import { useHistory } from "react-router"
import { GenerateRandomNumber, GetCollection, UpdateDocument } from "../../../firebase/firebase"

export const RecipeCategoriesWrapper = () => {
    const [categories, setCategories] = useState([])
    useEffect(() => {
        GetCollection('recipeCategories', false).then((data) => {
            setCategories(data.docs.map((doc) => doc.data()))
        })
        console.log(categories)
        console.log('hi')
    }, [])
    return (
        <>
            <Card>
                <Card.Body>
                    <Card.Header>
                        Add/Edit Recipe Categories
                    </Card.Header>
                    <Row>
                        <Col md={3}>
                            <AddRecipeCategoryCard />
                        </Col>
                        {categories && categories.map((category, idx) => {
                            return (
                                <Col md={3} key={idx} >
                                    <RecipeCategoryCard category={category}/>
                                </Col>
                            )
                        })}
                    </Row>
                </Card.Body>
            </Card>
        </>
    )
}

const RecipeCategoryCard = (props) => {
    const [category, setCategory] = useState(props.category)
    const history = useHistory()
    const [image, setImage] = useState('')



    return (
        <>
            <Card className='h-100'>
                <Card.Img variant="top" src={category.image} style={{ height: '275px', width: 'auto' }} />
                <Card.Body>
                    <Card.Title>
                        {category.title}
                    </Card.Title>
                    
                    <Card.Text>
                        {category.description}
                    </Card.Text>
                    
                </Card.Body>
            </Card>
        </>
    )

}

const AddRecipeCategoryCard = () => {
    const history = useHistory()
    const [category, setCategory] = useState({
        id: '',
        title: '',
        image: '',
        description: ''
    })
    const [image, setImage] = useState('')

    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            let temp = { ...category }
            temp.id = GenerateRandomNumber()
            temp.imagePath = `/recipeCategories/${temp.id}CategoryImage`
            await UpdateDocument('recipeCategories', temp, true)
            history.push(`recipes/viewCategory/${temp.id}`)
        }
        catch (e) {
            console.log(e)
        }
    }

    const onChange = (e) => {
        setCategory({ ...category, [e.target.name]: e.target.value })
    }

    const onImageChange = async (e) => {
        const image = e.target.files[0]
        if (image) {
            setCategory({ ...category, ['image']: image })
            setImage(URL.createObjectURL(image))
        }
        else {
            return 'Error'
        }

    }

    return (
        <>
            <Card className='h-100'>
                <Card.Body>
                    <Card.Header>
                        Add Recipe Category
                    </Card.Header>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={6} className='text-center mx-auto d-block'>
                                <Card.Img
                                    variant='top'
                                    src={image}
                                    
                                    style={{ height: '275px', width: 'auto' }}
                                />
                                <label className='btn btn-primary' htmlFor='recipeImage'>Select Image</label>
                                <input id='recipeImage' type='file' onChange={onImageChange} style={{ display: 'none' }}></input>
                            </Col>
                        </Row>
                        <Row className='py-2'>
                            <Form.Control
                                type='text'
                                onChange={onChange}
                                placeholder="Title"
                                value={category.title}
                                name="title"

                            />
                        </Row>
                        <Row className='py-2'>
                            <Form.Control

                                onChange={onChange}
                                as="textarea"
                                rows={4}
                                required
                                placeholder="Description"
                                value={category.description}
                                name='description'
                            />
                        </Row>
                        <Row className='py-2'>
                            <Button type='submit'>Submit</Button>
                        </Row>
                    </Form>
                </Card.Body>
            </Card>
        </>
    )
}